export const REPORT_STORED_TYPE_DEBT_MONTH = 'SERVICE_DEBT_BY_MONTH';
